import hasFullName from './utilities/hasFullName';
import hasTrainingTracker from './utilities/hasTrainingTracker';

const oit = (oitJson) => {
  const properties = {
    ...oitJson.attributes,
    guid: oitJson.guid,
    active: oitJson.active
  };
  return Object.assign(
    properties,
    hasFullName(oitJson.attributes),
    { trainingTracker: oitJson.attributes.trainingTracker ? hasTrainingTracker(oitJson.attributes.trainingTracker): null },
  );
};

export default oit;
